import { SITE } from '../data/fleet'

export default function TopBar() {
  return (
    <header className="topbar">
      <div className="wrap topbar__inner">
        <a className="topbar__mark" href="/#top">
          Golden <span>Mule</span> Rentals
        </a>

        <nav className="topbar__nav" aria-label="Main">
          <a className="topbar__link" href="/#fleet">Fleet</a>
          <a className="topbar__link" href="/#rates">Rates</a>
          <a className="topbar__link" href="/#coverage">Delivery area</a>
          <a className="topbar__link" href="/#contact">Contact</a>
        </nav>

        <a className="topbar__call" href={SITE.phoneHref}>
          {SITE.phone}
        </a>
      </div>
    </header>
  )
}
